import React, { ReactNode, useState } from "react";

import { Button } from "~/shared/components/ui/Button/Button";

interface ExpandableGridProps<T> {
  title?: string;
  items: T[];
  maxVisible?: number;
  renderCard: (item: T, idx: number) => ReactNode;
}

export function ExpandableGrid<T>({
  title,
  items,
  maxVisible = 3,
  renderCard,
}: ExpandableGridProps<T>) {
  const [showAll, setShowAll] = useState(false);

  const visibleItems = items.slice(0, maxVisible);
  const extraItems = items.slice(maxVisible);

  return (
    <section className="px-2">
      {title && (
        <h2 className="font-ivy text-indigo mb-4 text-3xl font-medium">
          {title}
        </h2>
      )}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 md:grid-cols-3">
        {visibleItems.map((item, idx) => renderCard(item, idx))}
      </div>
      <div
        className={`grid grid-cols-1 gap-5 overflow-hidden transition-all duration-500 ease-in-out sm:grid-cols-2 md:grid-cols-3 ${
          showAll ? "mt-5 max-h-[2000px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        {extraItems.map((item, idx) => renderCard(item, idx + maxVisible))}
      </div>
      {items.length > maxVisible && (
        <div className="mt-6 flex justify-center">
          <Button
            variant="outline-hub"
            className="px-8 py-2 font-medium"
            onClick={() => setShowAll((prev) => !prev)}
          >
            {showAll ? "Show less" : "Show more"}
          </Button>
        </div>
      )}
    </section>
  );
}
